import { Button } from '@vibTheme/components/_base/Button';
import { Typography } from '@vibTheme/components/_base/Typography';
import CloseIcon from '@mui/icons-material/Close';
import { useRouter } from 'next/router';

type Props = {
  title: string;
  body: string;
  ctaLabel: string;
  ctaHref: string;
  onDismiss: () => void;
};

export const DiscoveryCard = (props: Props) => {
  const router = useRouter();

  return (
    <aside className="border border-solid border-grayDivider rounded p-main grid gap-sm mb-main">
      <div className="flex justify-between items-start gap-md">
        <Typography component="h2" variant="h3">
          {props.title}
        </Typography>
        <button
          onClick={props.onDismiss}
          aria-label="Dispensar aviso"
          className="bg-transparent border-0 cursor-pointer p-0"
        >
          <CloseIcon className="w-[18px] h-[18px] text-lightBlack" />
        </button>
      </div>
      <Typography className="text-lightBlack">{props.body}</Typography>
      <div>
        <Button onClick={() => router.push(props.ctaHref)}>
          {props.ctaLabel}
        </Button>
      </div>
    </aside>
  );
};
